module.exports = __webpack_public_path__ + "static/media/header_aidefaq.17fb223d.jpg";